module.exports = __webpack_public_path__ + "img/OPI-Banner-03.aee7c27e.jpg";